import { BaseRepository } from './baseRepository'
import { CRUISE_DESTINATION_DETAIL, ROUTE_DETAIL } from './cruiseCompassRepository.graphql'

export class CruiseCompassRepository extends BaseRepository {

  async getCruiseDestinationDetail(
    departureType,
    departureId,
    cruiseId,
    citizenshipIds,
    restrictionType,
    cruiseDateStart,
    organisation,
    transitTypes,
    transitIds,
  ) {
    return await this.query(
      CRUISE_DESTINATION_DETAIL, {
        departureType: departureType,
        departureId: departureId,
        cruiseId: cruiseId,
        citizenshipIds: citizenshipIds,
        restrictionType: restrictionType,
        cruiseDateStart: cruiseDateStart,
        organisation: organisation,
        transitTypes: transitTypes,
        transitIds: transitIds
      },
      'cruiseDestinationDetail'
    )
  }

  async getRouteDetails(shippingLineId = null, shipId = null, routeId = null) {
    const variables = { };

    if (shippingLineId !== null) {
      variables.shippingLine = shippingLineId;
    }
    if (shipId !== null) {
      variables.ship = shipId;
    }

    if (routeId !== null) {
      variables.route = routeId;
    }

    return await this.query(
      ROUTE_DETAIL, 
      variables, 
      'routes'
    )
  }

}